"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AiRecommendationsApi = exports.AiRecommendationsApiFactory = exports.AiRecommendationsApiFp = exports.AiRecommendationsApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// @ts-ignore
const base_1 = require("../base");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
/**
 * AiRecommendationsApi - axios parameter creator
 * @export
 */
const AiRecommendationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns AI-generated content recommendations from the AI router service, formatted as dynamic Care Plan recommendations.  Requires circle-level authentication and read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | r |
         * @summary Get AI-generated content recommendations for the users in the circle.
         * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
         * @param {number} recipientId Recipient ID for whom to retrieve AI recommendations
         * @param {boolean} [forceRefresh] The backend has a configurable cache to not recalculate AI Recommendations for a certain duration. 1. Must be set to &#x60;true&#x60; the first time the user selects the circle so that the recommendations are recalculated with this new user in the circle. 2. If there is a need to force a recalculation then this is set to true. For example, after a user updates their goals, this should be set to true since we know goals impact AI Recommendations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1RecommendationsRecipientsRecipientIdAiRecommendations: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, forceRefresh, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getV1RecommendationsRecipientsRecipientIdAiRecommendations', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getV1RecommendationsRecipientsRecipientIdAiRecommendations', 'recipientId', recipientId);
            const localVarPath = `/v1/recommendations/recipients/{recipient_id}/ai-recommendations`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (forceRefresh !== undefined) {
                localVarQueryParameter['forceRefresh'] = forceRefresh;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/recommendations/recipients/{recipient_id}/ai-recommendations`,
                sdkMethod: 'getV1RecommendationsRecipientsRecipientIdAiRecommendations',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates the state of an AI-generated recommendation (e.g., mark as completed, declined, snoozed). Reuses existing Circle Recommendation update functionality for consistency.  Requires circle-level authentication and write permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | w |
         * @summary Update state of an AI recommendation
         * @param {number} recipientId Recipient ID for whom to update AI recommendations
         * @param {string} recommendationDefnId Recommendation Definition ID to update
         * @param {RbcUpdateRecRequest} rbcUpdateRecRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchV1RecommendationsRecipientsRecipientIdAiRecommendationsRecommendationDefnId: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, recommendationDefnId, rbcUpdateRecRequest, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('patchV1RecommendationsRecipientsRecipientIdAiRecommendationsRecommendationDefnId', 'recipientId', recipientId);
            // verify required parameter 'recommendationDefnId' is not null or undefined
            (0, common_1.assertParamExists)('patchV1RecommendationsRecipientsRecipientIdAiRecommendationsRecommendationDefnId', 'recommendationDefnId', recommendationDefnId);
            // verify required parameter 'rbcUpdateRecRequest' is not null or undefined
            (0, common_1.assertParamExists)('patchV1RecommendationsRecipientsRecipientIdAiRecommendationsRecommendationDefnId', 'rbcUpdateRecRequest', rbcUpdateRecRequest);
            const localVarPath = `/v1/recommendations/recipients/{recipient_id}/ai-recommendations/{recommendation_defn_id}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'recommendation_defn_id'}}`, encodeURIComponent(String(recommendationDefnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers
                ? baseOptions.headers
                : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/recommendations/recipients/{recipient_id}/ai-recommendations/{recommendation_defn_id}`,
                sdkMethod: 'patchV1RecommendationsRecipientsRecipientIdAiRecommendationsRecommendationDefnId',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rbcUpdateRecRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AiRecommendationsApiAxiosParamCreator = AiRecommendationsApiAxiosParamCreator;
/**
 * AiRecommendationsApi - functional programming interface
 * @export
 */
const AiRecommendationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AiRecommendationsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Returns AI-generated content recommendations from the AI router service, formatted as dynamic Care Plan recommendations.  Requires circle-level authentication and read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | r |
         * @summary Get AI-generated content recommendations for the users in the circle.
         * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
         * @param {number} recipientId Recipient ID for whom to retrieve AI recommendations
         * @param {boolean} [forceRefresh] The backend has a configurable cache to not recalculate AI Recommendations for a certain duration. 1. Must be set to &#x60;true&#x60; the first time the user selects the circle so that the recommendations are recalculated with this new user in the circle. 2. If there is a need to force a recalculation then this is set to true. For example, after a user updates their goals, this should be set to true since we know goals impact AI Recommendations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1RecommendationsRecipientsRecipientIdAiRecommendations(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getV1RecommendationsRecipientsRecipientIdAiRecommendations(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates the state of an AI-generated recommendation (e.g., mark as completed, declined, snoozed). Reuses existing Circle Recommendation update functionality for consistency.  Requires circle-level authentication and write permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | w |
         * @summary Update state of an AI recommendation
         * @param {number} recipientId Recipient ID for whom to update AI recommendations
         * @param {string} recommendationDefnId Recommendation Definition ID to update
         * @param {RbcUpdateRecRequest} rbcUpdateRecRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchV1RecommendationsRecipientsRecipientIdAiRecommendationsRecommendationDefnId(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.patchV1RecommendationsRecipientsRecipientIdAiRecommendationsRecommendationDefnId(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.AiRecommendationsApiFp = AiRecommendationsApiFp;
/**
 * AiRecommendationsApi - factory interface
 * @export
 */
const AiRecommendationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AiRecommendationsApiFp)(configuration);
    return {
        /**
         * Returns AI-generated content recommendations from the AI router service, formatted as dynamic Care Plan recommendations.  Requires circle-level authentication and read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | r |
         * @summary Get AI-generated content recommendations for the users in the circle.
         * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
         * @param {number} recipientId Recipient ID for whom to retrieve AI recommendations
         * @param {boolean} [forceRefresh] The backend has a configurable cache to not recalculate AI Recommendations for a certain duration. 1. Must be set to &#x60;true&#x60; the first time the user selects the circle so that the recommendations are recalculated with this new user in the circle. 2. If there is a need to force a recalculation then this is set to true. For example, after a user updates their goals, this should be set to true since we know goals impact AI Recommendations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1RecommendationsRecipientsRecipientIdAiRecommendations(params, options) {
            return localVarFp
                .getV1RecommendationsRecipientsRecipientIdAiRecommendations(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Updates the state of an AI-generated recommendation (e.g., mark as completed, declined, snoozed). Reuses existing Circle Recommendation update functionality for consistency.  Requires circle-level authentication and write permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | w |
         * @summary Update state of an AI recommendation
         * @param {number} recipientId Recipient ID for whom to update AI recommendations
         * @param {string} recommendationDefnId Recommendation Definition ID to update
         * @param {RbcUpdateRecRequest} rbcUpdateRecRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchV1RecommendationsRecipientsRecipientIdAiRecommendationsRecommendationDefnId(params, options) {
            return localVarFp
                .patchV1RecommendationsRecipientsRecipientIdAiRecommendationsRecommendationDefnId(params, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.AiRecommendationsApiFactory = AiRecommendationsApiFactory;
/**
 * AiRecommendationsApi - object-oriented interface
 * @export
 * @class AiRecommendationsApi
 * @extends {BaseAPI}
 */
class AiRecommendationsApi extends base_1.BaseAPI {
    /**
     * URL `/v1/recommendations/recipients/{recipient_id}/ai-recommendations`
     * Returns AI-generated content recommendations from the AI router service, formatted as dynamic Care Plan recommendations.  Requires circle-level authentication and read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | r |
     * @summary Get AI-generated content recommendations for the users in the circle.
     * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
     * @param {number} recipientId Recipient ID for whom to retrieve AI recommendations
     * @param {boolean} [forceRefresh] The backend has a configurable cache to not recalculate AI Recommendations for a certain duration. 1. Must be set to &#x60;true&#x60; the first time the user selects the circle so that the recommendations are recalculated with this new user in the circle. 2. If there is a need to force a recalculation then this is set to true. For example, after a user updates their goals, this should be set to true since we know goals impact AI Recommendations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiRecommendationsApi
     */
    getV1RecommendationsRecipientsRecipientIdAiRecommendations(params, options) {
        return (0, exports.AiRecommendationsApiFp)(this.configuration)
            .getV1RecommendationsRecipientsRecipientIdAiRecommendations(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/recommendations/recipients/{recipient_id}/ai-recommendations/{recommendation_defn_id}`
     * Updates the state of an AI-generated recommendation (e.g., mark as completed, declined, snoozed). Reuses existing Circle Recommendation update functionality for consistency.  Requires circle-level authentication and write permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | w |
     * @summary Update state of an AI recommendation
     * @param {number} recipientId Recipient ID for whom to update AI recommendations
     * @param {string} recommendationDefnId Recommendation Definition ID to update
     * @param {RbcUpdateRecRequest} rbcUpdateRecRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiRecommendationsApi
     */
    patchV1RecommendationsRecipientsRecipientIdAiRecommendationsRecommendationDefnId(params, options) {
        return (0, exports.AiRecommendationsApiFp)(this.configuration)
            .patchV1RecommendationsRecipientsRecipientIdAiRecommendationsRecommendationDefnId(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.AiRecommendationsApi = AiRecommendationsApi;
//# sourceMappingURL=ai-recommendations-api.js.map